import ov_1 from './ov_1.jpg';
import ov_2 from './ov_2.jpg';
import ov_3 from './ov_3.jpg';
import ov_4 from './ov_4.jpg';
import ov_5 from './ov_5.jpg';
import ov_6 from './ov_6.jpg';
import ov_7 from './ov_7.jpg';
import ov_8 from './ov_8.jpg';
import ov_9 from './ov_9.jpg';
import ov_10 from './ov_10.jpg';
import ov_11 from './ov_11.jpg';
import ov_12 from './ov_12.png';

export default [
  undefined, ov_1, ov_2, ov_3, ov_4, ov_5, ov_6, ov_7, ov_8, ov_9, ov_10, ov_11, ov_12
]


// WEBPACK FOOTER //
// ./src/assets/img/llc/contact/ov/index.js